import { BattleInterface, GameInterface} from "./types"

/**
 * calculates pearson correlation
 * @param {number[]} d1
 * @param {number[]} d2
 */
export function corr(d1:number[], d2:number[]):number {
  let { min, pow, sqrt } = Math
  let add = (a:number, b:number) => a + b
  let n = min(d1.length, d2.length)
  if (n === 0) {
    return 0
  }
  [d1, d2] = [d1.slice(0, n), d2.slice(0, n)]
  let [sum1, sum2] = [d1, d2].map(l => l.reduce(add))
  let [pow1, pow2] = [d1, d2].map(l => l.reduce((a, b) => a + pow(b, 2), 0))
  let mulSum = d1.map((n, i) => n * d2[i]).reduce(add)
  let dense = sqrt((pow1 - pow(sum1, 2) / n) * (pow2 - pow(sum2, 2) / n))
  if (dense === 0) {
    return 0
  }
  return (mulSum - (sum1 * sum2 / n)) / dense
}

export const mapTypeAvailable = [ 
  {'column':'is_special', 'name':'Special', 'value':1},
  {'column':'is_special', 'name':'Is not special', 'value':0},
];

export const gameTypesAvailable = [
  { name: 'Casual 2 teams (elo, no bots)',
    'func_filter': ((d:BattleInterface,row:number) => d.is_elo[row]===1 && d.is_teams[row]===1 && d.is_ffa[row]===0 && d.has_bots[row]!==1),
  },
  { name: 'Casual 2 teams (no elo, no bots)',
    'func_filter': ((d:BattleInterface,row:number) => d.is_elo[row]===0 && d.is_teams[row]===1 && d.is_ffa[row]===0 && d.has_bots[row]!==1),
  },
  { name: 'Bots (no chicken)',
    'func_filter': ((d:BattleInterface,row:number) => d.has_bots[row]===1 && d.is_chicken[row]!==1),
  },
  { name: 'Bots (chicken)',
    'func_filter': ((d:BattleInterface,row:number) => d.has_bots[row]===1 && d.is_chicken[row]===1),
  },
  { name: 'Matchmaker 1v1',
    'func_filter': ((d:BattleInterface,row:number) => d.is_matchmaker[row]===1 && d.is_1v1[row]===1),
  },
  { name: 'Matchmaker teams',
    'func_filter': ((d:BattleInterface,row:number) => d.is_matchmaker[row]===1 && d.is_teams[row]===1 && d.is_1v1[row]===0),
  },
  { name: 'FFA (>3 teams)',
    'func_filter': ((d:BattleInterface,row:number) => d.is_matchmaker[row]===0 && d.is_ffa[row]===1 && d.has_bots[row]!==1),
  },
  { name: 'Casual 1v1',
    'func_filter': ((d:BattleInterface,row:number) => d.is_matchmaker[row]===0 && d.is_teams[row]===0 && d.is_ffa[row]===0 && d.has_bots[row]!==1),
  },
];

export function getParameterFromHash(hash:string, param:string, default_value:string|null=null): string|null {
  let default_return = default_value;
  if(hash.indexOf("?")===-1) {
    return default_return;
  }
  var hash1 = hash.slice(hash.indexOf("?")+1);
  var idx1 = hash1.indexOf(param+"=");
  if(idx1===-1) {
    return default_return;
  }
  var hash2 = hash1.slice(idx1);
  var idx2 = hash2.indexOf("=");
  if(idx2===-1) {
    return default_return;
  }
  var idx3 = hash2.indexOf("&");
  if(idx3===-1) {
    idx3 = hash2.length;
  }
  return hash2.slice(idx2+1, idx3)
}

export function binary_search(a:number[], value:number, lower=false, upper=false, limit=true) {
    var lo = 0, hi = a.length - 1, mid;
    while (lo <= hi) {
      mid = Math.floor((lo+hi)/2);
      if (a[mid] > value)
        hi = mid - 1;
      else if (a[mid] < value)
        lo = mid + 1;
      else
        break;
    }
    if(mid===undefined) {
      throw new Error("binary_search failed (empty array)")
    }
    // If no exact match we return in which "bucket" would value fit
    if(a[mid]!==value) {
      if (a[mid]>value) {
        mid = lower ? mid-1 : mid;
      } else {
        mid = upper ? mid+1 : mid;
      }
    } else {
      if(lower) {
          while(mid>0 && a[mid-1]===a[mid]) {
            mid--;
          }
      }

      return mid;
    };

    if(limit) {
      return (mid>=0) ? mid : 0;
    } else {
      return (mid<=a.length-1) ? mid : a.length-1;
    }
}
